import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const isE2E = process.env.REACT_APP_E2E === "true";
const useLocalFirestoreOverride =
  process.env.REACT_APP_LOCAL_FIRESTORE_OVERRIDE === "true";
const e2eProjectId = "demo-bondready-e2e";

let firebaseConfig;

if (isE2E) {
  const configuredProjectId =
    process.env.REACT_APP_FIREBASE_PROJECT_ID ?? e2eProjectId;

  if (configuredProjectId !== e2eProjectId) {
    throw new Error(
      `E2E mode requires Firebase project ${e2eProjectId}; received ${configuredProjectId}`
    );
  }

  firebaseConfig = {
    apiKey: "demo-bondready-e2e",
    authDomain: "demo-bondready-e2e.firebaseapp.com",
    projectId: e2eProjectId,
    storageBucket: "demo-bondready-e2e.appspot.com",
    messagingSenderId: "000000000000",
    appId: "1:000000000000:web:0000000000000000000000"
  };
} else {
  // Firebase configuration for constructpay-prod-2025
  // Values can be overridden via environment variables
  firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBqN5oWdEKaVANMXVOIhkAvviBEJJmrAj0",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "constructpay-prod-2025.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "constructpay-prod-2025",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "constructpay-prod-2025.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "407903215609",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:407903215609:web:51dab5dab8bc9a6e7d2728",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-QF3EWQK58E"
  };
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

if (isE2E) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
} else if (useLocalFirestoreOverride) {
  // Local QA only: retain real Firebase Auth while resolving Firestore reads locally.
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}

export const storage = getStorage(app);
export default app;
